import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
// The router lives under /dashboard. nginx serves the app for every path, so a link to
// /register (website, old mails) rendered an empty page. Move such paths under the
// basename before the router starts; query and hash (ad click ids!) travel along.
if (!/^\/dashboard(\/|$)/.test(window.location.pathname) && window.location.pathname !== '/') {
  window.location.replace(`/dashboard${window.location.pathname}${window.location.search}${window.location.hash}`);
}
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import ReactDOM from 'react-dom/client';
import App from './App';
import config from './config';
import './i18n';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// Set logger level when not in production
if (import.meta.env.DEV) {
  const loggerBaseString: string = config.loggerBaseString || 'dashboard-react';
  localStorage.setItem('debug', `${loggerBaseString}:*`);
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>
);
